import Component from '@glimmer/component';
import config from 'frontend/config/environment';

export default class FooterSupportersComponent extends Component {
  get wpUrl() {
    return config.wpUrl;
  }
}
